var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25018 18.5C2.25018 15.3181 2.25018 13.7271 3.2387 12.7385C4.22721 11.75 5.8182 11.75 9.00018 11.75H18.0002C21.1821 11.75 22.7731 11.75 23.7616 12.7385C24.7502 13.7271 24.7502 15.3181 24.7502 18.5C24.7502 21.6819 24.7502 23.2729 23.7616 24.2615C22.7731 25.25 21.1821 25.25 18.0002 25.25H9.00018C5.8182 25.25 4.22721 25.25 3.2387 24.2615C2.25018 23.2729 2.25018 21.6819 2.25018 18.5Z",
    stroke: "#ED484B",
    strokeWidth: 1.625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.75V9.5C6.75 5.77208 9.77208 2.75 13.5 2.75C17.2279 2.75 20.25 5.77208 20.25 9.5V11.75",
    stroke: "#ED484B",
    strokeWidth: 1.625,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00018 18.5H9.01031M13.4901 18.5H13.5002M17.9901 18.5H18.0002",
    stroke: "#ED484B",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.45739bcb11acd6cb0485e0783c726cfc.svg";
export { ForwardRef as ReactComponent };